import { c as _c } from "react/compiler-runtime";
export function Views(t0) {
  const $ = _c(9);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = count?.toLocaleString();
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="mr-1 font-normal">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = count > 1 && "s";
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="text-sm font-light">view{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div>{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}